import { ISColumn } from "../is-table/is-table";
import { ISFilterAPI, ISPagination } from "../models/api";

export class ISMultiSelectDatasource {
    constructor(
        public columns: ISColumn[],
        public parentColumns?: ISColumn[],
        public body?: any[],
        public pagination: ISPagination = { pageSize: 10, page: 1 },
        public totalItems: number = 0,
        public apiUrl: string | undefined = undefined,
        public filters?: ISFilterAPI[],
        public styleConditions?: ISMultiSelectStyleObject[]
    ) { }
}

export class ISMultiSelectOption {
    constructor(
        public value: any,
        public label: string,
        public icon?: string,
        public style?: string,
        public children?: ISMultiSelectOption[],
        public disabled?: boolean
    ) { 
        if (disabled == null) {
            disabled = false;
        }
    }
}

export class ISMultiSelectStyleObject {
    constructor(
        public style: string,
        public conditionFunction: StyleConditionalFunction
    ) { }
}

export type StyleConditionalFunction = (multiselectBody: any) => boolean;